<template lang="pug">
  .curriculum-steps-field
    curriculum-step-field(
      v-for="(step, index) in steps"
      :index="index"
      :key="index"
      :value="step"
      @input="value => updateItem(value, index)"
      @remove="remove(index)"
      @upload="$emit('upload', $event)"
    )

    add-step-button(@click="add")
</template>

<style lang="scss" scoped>
.curriculum-step-field,
.add-step-button {
  margin-top: 16px;
}
</style>

<script>
import CurriculumStepField from '@/components/organisms/CurriculumStepField'
import AddStepButton from '@/components/molecules/AddStepButton'

export default {
  props: {
    value: { type: Array },
  },
  components: {
    CurriculumStepField,
    AddStepButton,
  },
  computed: {
    steps() {
      if (this.value.length > 0) {
        return this.value
      } else {
        return [this.createBlank()]
      }
    },
  },
  methods: {
    createBlank() {
      return {
        description: '',
        videoKey: null,
        thumbnailKey: null,
      }
    },
    add() {
      this.$emit('input', this.steps.concat([this.createBlank()]))
    },
    remove(index) {
      this.$emit('input', [
        ...this.steps.slice(0, index),
        ...this.steps.slice(index + 1),
      ])
    },
    updateItem(item, index) {
      const newValue = [
        ...this.value.slice(0, index),
        item,
        ...this.value.slice(index + 1),
      ]
      this.$emit('input', newValue)
    },
  },
}
</script>
